import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import "./i18n";
import App from './App';
// const lang = localStorage.getItem('lang') || 'fr';
// document.documentElement.lang = lang;
// document.documentElement.dir = lang === 'ar' ? 'rtl' : 'ltr';
const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
    <App />
);